<template>
  <div class="dashboard-container">
    <div class="cards-wrapper">
      <!-- Card 1: Inventory Management -->
      <div class="card card-inventory" @click="goToInventory" role="button" tabindex="0" @keyup.enter="goToInventory">
        <div class="card-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>
            <path d="M3.27 6.96L12 12.01l8.73-5.05"/>
            <path d="M12 22.08V12"/>
          </svg>
        </div>
        <h2 class="card-title">جرد المستودع</h2>
        <p class="card-description">إدارة المخزون والمواد المتاحة في المستودع بكفاءة</p>
        <!-- اضغط على الكارد للانتقال -->
      </div>

      <!-- Card 2: Transfer Requests -->
      <!--<div class="card card-transfer" @click="goToTransferRequests" role="button" tabindex="0" @keyup.enter="goToTransferRequests">
        <div class="card-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M12 5v14M5 12l7 7 7-7"/>
            <path d="M5 12l7-7 7 7"/>
          </svg>
        </div>
        <h2 class="card-title">طلب نقل</h2>
        <p class="card-description">معالجة وتتبع طلبات نقل المواد بين المستودعات</p>        
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardCards',
  data() {
    return {}
  },
  methods: {
    goToInventory() {
      this.$router.push({name:'Inventory'})
    },
    /*goToTransferRequests() {
      this.$router.push({name:'Transfer'})
    }*/
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.dashboard-container {
  width: 100%;
  padding: 40px 20px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cards-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  max-width: 900px;
  width: 100%;
}

.card {
  background: var(--surface);
  border: 1px solid rgba(16,24,40,0.06);
  border-radius: 12px;
  padding: 36px 26px;
  box-shadow: 0 8px 30px rgba(16,24,40,0.08);
  transition: all 0.3s ease;
  text-align: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, rgba(16,24,40,0.06), rgba(16,24,40,0.04));
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
}



.card-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--icon-bg, #f3f4f6);
  color: var(--icon-color, #1f2937);
}

.card-icon svg {
  width: 40px;
  height: 40px;
  stroke-width: 2;
}


.card-icon svg { stroke: #1f2937; }
.card-inventory {
  --icon-bg: linear-gradient(135deg,#667eea 0%, #7b6ff0 100%);
  --icon-color: #ffffff;
}

.card-transfer {
  --icon-bg: linear-gradient(135deg,#764ba2 0%, #8b63d9 100%);
  --icon-color: #ffffff;
}

.card-inventory .card-icon svg,
.card-transfer .card-icon svg {
  stroke: #fff;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin: 16px 0 12px;
  direction: rtl;
}

.card-description {
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
  margin: 12px 0 20px;
  direction: rtl;
}


.card:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(43,138,239,0.08);
  transform: translateY(-4px);
}

.btn-card:active {
  transform: scale(0.98);
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 20px 10px;
  }

  .cards-wrapper {
    gap: 20px;
  }

  .card {
    padding: 30px 20px;
  }

  .card-title {
    font-size: 20px;
  }

  .card-description {
    font-size: 13px;
  }
}
</style>
